module.exports = __webpack_public_path__ + "img/Iconen Class Action website-05.728eef7c.svg";